<template>
    <div>
        <rkm-list
            v-if="!readonly"
            :items="data.model.prescricaoMedicamentos"
            hide-filters
            hide-pagination
            item-cursor="default"
        >
            <template v-slot="{item}">
                <rkm-row v-if="item.isManual">
                    <rkm-col>
                        <strong>Descrição</strong><br/>
                        <div v-html="formatDescricao(item.descricao)"></div>
                    </rkm-col>

                    <rkm-col v-if="item.justificativa">
                        <strong>Justificativa</strong><br/>
                        <div v-html="formatDescricao(item.justificativa)"></div>
                    </rkm-col>
                    <rkm-col v-else><strong>Justificativa</strong><br/>-</rkm-col>
                </rkm-row>

                <template v-else>
                    <rkm-row>
                        <rkm-col>
                            <strong>Medicamento</strong><br/>{{item.material.descricao}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Via de administração</strong><br/>{{item.material.viaAdministracao}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Unidade de medida</strong><br/>{{item.unidadeMedida}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Tipo</strong><br/>{{item.material.receitaTipo}}
                        </rkm-col>
                    </rkm-row>
                </template>

                <rkm-row>
                    <rkm-col v-if="item.isManual">
                        <strong>Recomendações</strong><br/>
                        <div v-html="formatDescricao(item.recomendacoes)"></div>
                    </rkm-col>
                    <rkm-col v-else>
                        <strong>Recomendações</strong><br/>
                        {{item.recomendacoes}}
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:trailling="{index, item}">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(item, index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-list>

        <rkm-area
            :closed="readonly"
            background-color="primary"
            title="Histórico de prescrição de medicamentos"
            type="box"
        >
            <rkm-list
                :items="data.form.prescricoesMedicamentos"
                hide-filters
                hide-pagination
            >
                <template v-slot:leading="{item}">
                    <rkm-row>
                        <rkm-col>
                            <rkm-button
                                :color="item.revalidar ? 'danger' : 'primary'"
                                :title="item.revalidar ? 'Desfazer revalidação da prescrição de medicamento' : 'Revalidar prescrição de medicamento'"
                                @click.stop="handleRevalidarClick(item)"
                                small
                            >
                                <rkm-icon icon="calendar" />
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot="{item}">
                    <rkm-row>
                        <rkm-col>
                            <strong>Data / Hora</strong><br />{{item.dataHora}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Setor</strong><br />{{item.centroCusto.setor.nome}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Profissional</strong><br />{{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.nome}}
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:collapse="{item}">
                    <rkm-list
                        :items="item.medicamentos"
                        hide-filters
                        hide-pagination
                        item-cursor="default"
                        class="p-2"
                    >
                        <template v-slot="{item}">
                            <rkm-row v-if="item.isManual">
                                <rkm-col>
                                    <strong>Descrição</strong><br/>
                                    <div v-html="formatDescricao(item.descricao)"></div>
                                </rkm-col>
                                <rkm-col v-if="item.justificativa">
                                    <strong>Justificativa</strong><br/>
                                    <div v-html="formatDescricao(item.justificativa)"></div>
                                </rkm-col>
                                <rkm-col v-else>
                                    <strong>Justificativa</strong><br/>
                                    -
                                </rkm-col>
                            </rkm-row>

                            <template v-else>
                                <rkm-row>
                                    <rkm-col cols="3">
                                        <strong>Medicamento</strong><br/>{{item.materialDescricao}}
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <strong>Via de administração</strong><br/>{{item.materialViaAdministracao}}
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <strong>Posologia</strong><br/>{{item.posologia}}
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <strong>Dose única</strong><br/>{{item.isDoseUnica ? 'Sim' : 'Não'}}
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="3">
                                        <strong>Uso contínuo</strong><br/>{{item.isUsoContinuo ? 'Sim' : 'Não'}}
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <strong>Início do tratamento</strong><br/>{{item.inicio}}
                                    </rkm-col>

                                    <rkm-col
                                        v-if="!item.isUsoContinuo"
                                        cols="3"
                                    >
                                        <strong>Duração</strong><br/>{{item.duracaoDescricao}}
                                    </rkm-col>

                                    <rkm-col
                                        v-if="item.conclusao"
                                        cols="3"
                                    >
                                        <strong>Conclusão do tratamento</strong><br/>{{item.conclusao}}
                                    </rkm-col>
                                </rkm-row>
                            </template>

                            <rkm-row>
                                <rkm-col>
                                    <strong>Recomendações</strong><br/>{{item.recomendacoes || '&nbsp;'}}
                                </rkm-col>
                            </rkm-row>

                            <template v-if="!item.isManual && item.isTratamentoInterrompido">
                                <rkm-row>
                                    <rkm-col cols="3">
                                        <strong>Tratamento interrompido</strong><br/>{{item.tratamentoInterrompidoEm}}
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col>
                                        <strong>Justificativa do tratamento interrompido</strong><br/>{{item.tratamentoInterrompidoJustificativa}}
                                    </rkm-col>
                                </rkm-row>
                            </template>
                        </template>
                    </rkm-list>
                </template>
            </rkm-list>
        </rkm-area>

        <Modal
            :data="data"
            ref="Modal"
        />

        <ModalPrescricao
            :data="data"
            ref="ModalPrescricao"
            @save="saveDuplicated"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'
import ModalPrescricao from './ModalPrescricao'

// Enums.
import frequenciaDose from '@/enums/ambulatorio/frequenciaDose'
import medidaTempo from '@/enums/cadastro/medidaTempo'
import tipoReceita from '@/enums/cadastro/medicamento/tipoReceita'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

export default {
    components: {Modal, ModalPrescricao},
    data: () => ({
        enums: {
            frequenciaDose,
            medidaTempo,
            tipoReceita
        },
        others: {moment},
    }),
    created() {
        this.repositories = {
            pdf: this.getConectaSusRepository('impressao.ambulatorio'),
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        medicamentoJaAdicionado(novoMedicamento) {

            return this.data.model.prescricaoMedicamentos.some(medicamento => {

                if (novoMedicamento.material && medicamento.material) {

                    return medicamento.material.id === novoMedicamento.material.id
                }

                if (!novoMedicamento.material && !medicamento.material) {

                    return novoMedicamento.prescricaoMedicamentoItemAnteriorId != null
                        && medicamento.prescricaoMedicamentoItemAnteriorId === novoMedicamento.prescricaoMedicamentoItemAnteriorId
                }

                return false
            })
        },
        destroy(item) {

            const objIndex = this.data.model.prescricaoMedicamentos.findIndex((obj => item.material ? (obj.material.id == item.material.id) : (obj.manualId == item.manualId)));

            const destroy = async () => this.data.model.prescricaoMedicamentos.splice(objIndex, 1)

            this.showDeleteConfirmation(`Deseja realmente excluir a prescrição de medicamento?`, destroy,  this.handleError)
        },
        print(item) {

            item.rascunho = true

            const payload = this.camelObjectKeysToSnakeRecursive({
                emAtendimento: true,
                atendimentoId: this.data.additionals.atendimentoId,
                multiple: true,
                medicamentos: [item],
            })

            let request = null

            if (item.isManual) {
                if (item.receitaTipoId == this.enums.tipoReceita.ESPECIAL) {
                    request = this.repositories.pdf.receitaMedicaNaoPadronizadaEspecial(this.data.additionals.paciente.id, payload)
                } else {
                    request = this.repositories.pdf.receitaMedicaNaoPadronizadaComum(this.data.additionals.paciente.id, payload)
                }
            } else if (item.material.receitaTipoId == this.enums.tipoReceita.ESPECIAL) {

                request = this.repositories.pdf.receitaMedicaEspecial(this.data.additionals.paciente.id, payload)
            } else if (item.material.receitaTipoId == this.enums.tipoReceita.ESPECIAL_AMARELA) {

                request = this.repositories.pdf.receitaMedicaEspecialAmarela(this.data.additionals.paciente.id, payload)
            } else if (item.material.receitaTipoId == this.enums.tipoReceita.ESPECIAL_AZUL) {

                request = this.repositories.pdf.receitaMedicaEspecialAzul(this.data.additionals.paciente.id, payload)
            } else {
                request = this.repositories.pdf.receitaMedicaComum(this.data.additionals.paciente.id, payload)
            }

            request
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleRevalidarClick(item) {
            if (item.revalidar) {

                this.data.model.prescricaoMedicamentos = this.data.model.prescricaoMedicamentos
                    .filter(medicamento => medicamento.oldId !== item.id);

                item.revalidar = false
            } else {

                item.medicamentos.map(medicamento => {

                    const request = {
                        pacienteId: this.data.additionals.paciente.id,
                        medicamentoId: medicamento.materialId
                    }

                    this.setLoading()

                    this.repositories.atendimento.prescricaoMedicamento(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {

                            const include = () => {

                                const unidadeMedida = this.data.form.unidadesMedida.find(unidade => unidade.id == medicamento.unidadeMedidaId)

                                const novoMedicamento = {
                                    oldId: item.id,
                                    checked: medicamento.isImprimirSeparado,
                                    prescricaoMedicamentoItemAnteriorId: medicamento.id,
                                    isManual: medicamento.isManual,
                                    manualId: medicamento.isManual ? moment().format('x') : null,
                                    descricao: medicamento.descricao,
                                    material: medicamento.materialId ? {
                                        id: medicamento.materialId,
                                        descricao: medicamento.materialDescricao,
                                        viaAdministracao: medicamento.materialViaAdministracao,
                                        receitaTipoId: medicamento.materialReceitaTipoId ?? null,
                                        quantidade: medicamento.materialQuantidade ?? null,
                                        apresentacao: medicamento.materialApresentacaoNome ?? null,
                                        receitaTipo: medicamento.materialReceitaTipo ?? null
                                    } : null,
                                    receitaTipoId: medicamento.receitaTipoId,
                                    dose: medicamento.dose,
                                    unidadeMedidaId: medicamento.unidadeMedidaId,
                                    unidadeMedida: unidadeMedida ? unidadeMedida.nome : null,
                                    isDoseUnica: medicamento.isDoseUnica,
                                    frequenciaDose: medicamento.frequenciaDose,
                                    intervalo: medicamento.intervalo,

                                    intervaloMedidaTempoId: medicamento.frequenciaDose === this.enums.frequenciaDose.INTERVALO
                                        ? this.enums.medidaTempo.HORAS
                                        : medicamento.intervaloMedidaTempoId,

                                    frequenciaVezes: medicamento.frequenciaVezes,
                                    turnoId: medicamento.turnoId,
                                    isUsoContinuo: medicamento.isUsoContinuo,
                                    inicio: moment().format('DD/MM/YYYY'),
                                    duracao: medicamento.duracao,
                                    duracaoMedidaTempoId: medicamento.duracaoMedidaTempoId,
                                    recomendacoes: medicamento.recomendacoes,
                                    posologia: medicamento.posologia,
                                    isImprimirSeparado: medicamento.isImprimirSeparado,
                                    isRemoverImpressao: medicamento.isRemoverImpressao,
                                }

                                if (this.medicamentoJaAdicionado(novoMedicamento)) return

                                this.data.model.prescricaoMedicamentos.push(novoMedicamento)
                            }

                            if (response.data) {

                                if (this.data.additionals.permitePrescricaoRepetida) {

                                    this.$refs.ModalPrescricao.open(response.data, item)
                                } else {

                                    this.showAlert('Este paciente já possui uma prescrição para o medicamento e dentro do prazo de uso.', "Atenção");
                                }
                            } else {
                                include()
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })

                item.revalidar = true

                const exibeMsgPrescricao = this.data.model.prescricaoMedicamentos.find(medicamento => medicamento.material
                    && medicamento.material.id && medicamento.unidadeMedidaId === null)

                if (exibeMsgPrescricao) {

                    this.showAlert(`Existe prescrição sem unidade de medida informada. Para registrá-la,
                        é necessário fornecer essa informação`, 'Atenção')
                }
            }
        },
        saveDuplicated(item) {

            item.medicamentos.map(medicamento => {

                const unidadeMedida = this.data.form.unidadesMedida.find(unidade => unidade.id == medicamento.unidadeMedidaId)

                const novoMedicamento = {
                    oldId: item.id,
                    checked: medicamento.isImprimirSeparado,
                    prescricaoMedicamentoItemAnteriorId: medicamento.id,
                    isManual: medicamento.isManual,
                    manualId: medicamento.isManual ? moment().format('x') : null,
                    descricao: medicamento.descricao,
                    material: medicamento.materialId ? {
                        id: medicamento.materialId,
                        descricao: medicamento.materialDescricao,
                        viaAdministracao: medicamento.materialViaAdministracao,
                        receitaTipoId: medicamento.materialReceitaTipoId ?? null,
                        quantidade: medicamento.materialQuantidade ?? null,
                        apresentacao: medicamento.materialApresentacaoNome ?? null,
                        receitaTipo: medicamento.materialReceitaTipo ?? null
                    } : null,
                    receitaTipoId: medicamento.receitaTipoId,
                    dose: medicamento.dose,
                    unidadeMedidaId: medicamento.unidadeMedidaId,
                    unidadeMedida: unidadeMedida ? unidadeMedida.nome : null,
                    isDoseUnica: medicamento.isDoseUnica,
                    frequenciaDose: medicamento.frequenciaDose,
                    intervalo: medicamento.intervalo,

                    intervaloMedidaTempoId: medicamento.frequenciaDose === this.enums.frequenciaDose.INTERVALO
                        ? this.enums.medidaTempo.HORAS
                        : medicamento.intervaloMedidaTempoId,

                    frequenciaVezes: medicamento.frequenciaVezes,
                    turnoId: medicamento.turnoId,
                    isUsoContinuo: medicamento.isUsoContinuo,
                    inicio: moment().format('DD/MM/YYYY'),
                    duracao: medicamento.duracao,
                    duracaoMedidaTempoId: medicamento.duracaoMedidaTempoId,
                    recomendacoes: medicamento.recomendacoes,
                    posologia: medicamento.posologia,
                    isImprimirSeparado: medicamento.isImprimirSeparado,
                    isRemoverImpressao: medicamento.isRemoverImpressao,
                }

                if (this.medicamentoJaAdicionado(novoMedicamento)) return

                this.data.model.prescricaoMedicamentos.push(novoMedicamento)
            })

            item.revalidar = true

            const exibeMsgPrescricao = this.data.model.prescricaoMedicamentos.find(medicamento => medicamento.material
                && medicamento.material.id && medicamento.unidadeMedidaId === null)

            if (exibeMsgPrescricao) {

                this.showAlert(`Existe prescrição sem unidade de medida informada. Para registrá-la,
                    é necessário fornecer essa informação`, 'Atenção')
            }
        },
        formatDescricao(descricao) {

            if (descricao) {
                return descricao.replace(/\n/g, '<br>');
            }

            return null
        },
    },
    mixins: [error, file, repository, stringCase],
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, default: false},
    },
}
</script>